export enum DonationType {
  OneTime = 1,
  Recurring = 2,
  Pledge = 3
}
